"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelWarning = void 0;
var LabelWarning;
(function (LabelWarning) {
    LabelWarning["CUSTOM_SC_ENCODED_LABEL"] = "CUSTOM_SC_ENCODED_LABEL";
    LabelWarning["DIMS_OVERRIDE"] = "DIMS_OVERRIDE";
    LabelWarning["MISSING_DIMS"] = "MISSING_DIMS";
    LabelWarning["MISSING_WEIGHT"] = "MISSING_WEIGHT";
    LabelWarning["PHONE_NUMBER_OVERRIDE"] = "PHONE_NUMBER_OVERRIDE";
    LabelWarning["PREPURCHASED_LABEL"] = "PREPURCHASED_LABEL";
    LabelWarning["REPLACEMENT_LABEL"] = "REPLACEMENT_LABEL";
    LabelWarning["WEIGHT_OVERRIDE"] = "WEIGHT_OVERRIDE";
})(LabelWarning = exports.LabelWarning || (exports.LabelWarning = {}));
//# sourceMappingURL=ShippingLabel.js.map